import React, { FC, ReactNode } from 'react';
import cx from 'classnames';
import { VerticalSeparator } from '../VerticalSeparator/VerticalSeparator';

export type TArticleHeaderInfoToolbarElementProps = {
  children: ReactNode;
  hideOnMobiles: boolean;
  isFirst?: boolean;
};

const ArticleHeaderInfoToolbarElement: FC<TArticleHeaderInfoToolbarElementProps> = ({
  children,
  hideOnMobiles,
  isFirst,
}) => (
  <>
    {!isFirst && (
      <div
        className={cx({
          flex: !hideOnMobiles,
          'hidden sm:flex': hideOnMobiles,
        })}
      >
        <VerticalSeparator className="h-7" />
      </div>
    )}
    <div
      className={cx({
        flex: !hideOnMobiles,
        'hidden sm:flex': hideOnMobiles,
      })}
    >
      {children}
    </div>
  </>
);

export default ArticleHeaderInfoToolbarElement;
